export function formatMoney(minor, currency, locale) {
  const amount = Number(minor);
  if (!Number.isFinite(amount)) {
    return '—';
  }
  const code = String(currency || 'SAR').toUpperCase();
  const value = amount / 100;
  try {
    return new Intl.NumberFormat(locale === 'ar' ? 'ar-SA' : 'en-SA', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${code}`;
  }
}

export function createIdempotencyKey(prefix = 'purchase') {
  const random = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}-${random}`;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function buildCodesCsv(codes) {
  const rows = [['code']];
  (codes || []).forEach((entry) => {
    const code = typeof entry === 'string' ? entry : entry?.code;
    if (code) {
      rows.push([code]);
    }
  });
  return rows.map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
}

export async function copyText(text) {
  if (!text) {
    return false;
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  textarea.remove();
  return copied;
}

export function isPurchasePending(status) {
  return status === 'pending_payment';
}

export function isPurchasePaid(status) {
  return status === 'paid';
}

export function isPurchaseFailed(status) {
  return status === 'failed';
}

export function isPurchaseCancelled(status) {
  return status === 'cancelled';
}

export function isPurchaseRefunded(status) {
  return status === 'refunded';
}

export function canRevokeCode(code) {
  return code?.status === 'active' && code?.can_revoke !== false;
}
